export default function About() {
  return (
    <section id="about" className="py-24 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
              About <span className="text-[#C9A961]">British Custom Tailors</span>
            </h2>
            
            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              For over <strong className="text-white">five decades</strong>, British Custom Tailors has been the premier destination for discerning clients seeking <strong className="text-white">exquisite custom clothing</strong>. Our commitment to excellence and attention to detail has earned us a reputation as one of the finest custom tailoring services in the nation.
            </p>

            <p className="text-lg text-gray-300 mb-6 leading-relaxed">
              We specialize in creating <strong className="text-white">perfectly fitted custom suits and shirts</strong> for both men and women. Every garment is handcrafted by master tailors using traditional techniques combined with modern precision, ensuring exceptional quality and lasting durability.
            </p>

            <p className="text-lg text-gray-300 mb-8 leading-relaxed">
              Our <strong className="text-white">nationwide house call service</strong> brings the luxury of custom tailoring directly to you. Whether at your home or office, our expert consultants provide personalized service with hundreds of premium fabric options and style choices.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                <div className="text-3xl font-bold text-[#C9A961] mb-2">55+</div>
                <div className="text-sm text-gray-300">Years of Excellence</div>
              </div>
              <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
                <div className="text-3xl font-bold text-[#C9A961] mb-2">5,000+</div>
                <div className="text-sm text-gray-300">Satisfied Clients</div>
              </div>
            </div>

            <a 
              href="#consultation" 
              className="inline-block bg-[#C9A961] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#B89851] transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap"
            >
              Experience Our Craftsmanship
            </a>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://www.britishtailors.com/wp-content/uploads/2016/08/style_guide-e1471835477354.jpg"
                alt="British Custom Tailors craftsmanship"
                className="w-full h-[600px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-8 -left-8 bg-white rounded-2xl p-6 shadow-2xl">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 bg-[#C9A961] rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-3xl text-white"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">Premium</div>
                  <div className="text-sm text-gray-600">Masterfully Tailored</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}